module.exports = __webpack_public_path__ + "static/scale-model-of-st-joseph-cathedral-&-rectory-in-buffalo-new-york-f7656d51789cfdb66fcdbf6dc629e462.png";